import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import { getAccessToken } from '@/utils/auth';

// 创建一个不经过拦截器的 axios 实例，专门用于刷新 token
const refreshAxiosInstance = axios.create({
  timeout: 30 * 1000,
  withCredentials: true,
});

export const refreshAccessToken = () => {
  const accessToken = getAccessToken();
  const data = {
    placeholder: 'p',
  };
  return refreshAxiosInstance({
    url: '/sso-api/v1/token/refresh/at',
    method: 'POST',
    data,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const refreshRefreshToken = () => {
  // 更新rtk
  const accessToken = getAccessToken();
  const data = {
    placeholder: 'p',
  };
  // 使用 refreshAxiosInstance 避免再次进入拦截器导致死锁
  return refreshAxiosInstance({
    url: '/sso-api/v1/token/refresh/rt',
    method: 'POST',
    data,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const ssoLogout = () => {
  return axios.post('/sso-api/v1/logout', {
    placeholder: 'p',
  });
};

export function ssoLogin(ssoCode: string) {
  return axios.post('/sso-api/v1/token/exchange', {
    ssoCode,
    client_secret: 'lSyTX2a+xKog5gZN80PbM+Yo',
    app: 'knit',
  });
}

/**
 * 检查 access token 是否有效
 * @returns {Promise<CheckAccessTokenResponse>}
 * CheckAccessTokenResponse:
 * {
 *   code: number,
 *   msg: string,
 *   trace_id: string,
 *   data: {
 *     user_id: string,
 *     is_valid: boolean,
 *   }
 * }
 */
export const checkSsoTokenValid = () => {
  return axios.post<{
    user_id: string;
    is_valid: boolean;
  }>('/sso-api/v1/token/check', {});
};

export default {
  refreshAccessToken,
  refreshRefreshToken,
  checkSsoTokenValid,
};
